<template>
  <v-card max-width="290">
    <v-list-item three-line>
      <v-list-item-content>
        <div class="text-overline mb-4">
          LAT: {{ properties["lat"] }}, LON: {{ properties["lng"] }}
        </div>
        <v-list-item-title class="text-h5 mb-1">
          {{ properties["name"] }}
        </v-list-item-title>
        <v-list-item-subtitle class="mt-4">
          Datum: <b>{{ properties["timestamp"] }}</b><br/>
          Nutzbare Feldkapazität: <b>{{ properties["dataB1"] }} %</b><br/>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn :loading="loadingService" color="primary" @click="showDialog">
        plot
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ApiService from "@/services/api.service.js";

export default {
  name: "layerTimePopup",
  props: ["properties", "mapboxPopup"],
  data: () => ({
    headers: ["layerId", "timestamp", "lat", "lng", "dataB1"],
    items: [],
    loadingService: false,
  }),
  methods: {
    async showDialog() {
      let {lng, lat, keyLayer, timestamp, temporalResolution} = this.properties;
      lng = parseFloat(lng) ?? 0;
      lat = parseFloat(lat) ?? 0;
      this.loadingService = true;

      let url
      if (temporalResolution === "monthly") {
        url = `https://rastless.api.eomap.com/layers/${keyLayer}/statistic?token=c8c9633d-bf33-41d6-ab38-20666297ef92&temporal_resolution=monthly`;
      } else {
        let startDate = this.formatAddMonth();
        let endDate = timestamp;
        url = `https://rastless.api.eomap.com/layers/${keyLayer}/statistic?token=c8c9633d-bf33-41d6-ab38-20666297ef92&start_date=${startDate}T00:00:00&end_date=${endDate}T00:00:00&temporal_resolution=daily`;
      }

      let jsonParams = JSON.stringify({
        statistic: "median",
        geometry: {
          type: "Point",
          coordinates: [lng, lat]
        },
      });
      let result = await ApiService.post(url, jsonParams);
      this.loadingService = false;
      this.items = result["data"];
      this.setData();
      this.$store.commit("app/SET_PLOT_DIALOG", true);
    },
    setData() {
      let x = []
      let y = []

      const values = this.items.data.B1 || this.items.data["MEAN"]

      values.forEach((element, index) => {
        if (element != null) {
          x.push(this.items.datetime[index])
          y.push(element)
        }
      })

      const data = {
        x: x,
        y: y,
      };
      this.$store.commit("app/SET_PLOT_DATA", data);
      this.$store.commit("app/SET_PLOT_LAYOUT", this.properties.plotLayout);
    },
    formatDate(date) {
      if (!date) return null;
      date = date.replace("T00:00:00", "");
      const [year, month, day] = date.split("-");
      let dateFormat = "";
      if (month !== undefined && day === undefined) {
        dateFormat = `${year}-${month}`;
      } else if (month === undefined && day === undefined) {
        dateFormat = `${year}`;
      } else {
        dateFormat = `${year}-${month}-${day}`;
      }
      return dateFormat;
    },
    formatAddMonth() {
      let date, month, year;
      let inputDate = new Date(this.properties.timestamp);
      inputDate.setFullYear(inputDate.getFullYear() - 1);
      date = inputDate.getDate() + 1;
      month = inputDate.getMonth() + 1;
      year = inputDate.getFullYear();

      date = date.toString().padStart(2, '0');
      month = month.toString().padStart(2, '0');
      return `${year}-${month}-${date}`;
    }
  },
  mounted() {
    this.properties.timestamp = this.formatDate(this.properties.timestamp);
    this.properties.lat = this.properties.lat.toFixed(4);
    this.properties.lng = this.properties.lng.toFixed(4);
  },
};
</script>

<style scoped>
.scroll {
  overflow-y: scroll;
}
</style>

<style>
.mapboxgl-popup-content {
  padding: 0;
}

.mapboxgl-popup {
  max-width: 400px !important;
}

.mapboxgl-popup-close-button {
  width: 35px;
  height: 35px;
  font-size: 27px;
}

.colorPixel {
  width: 50px;
  height: 20px;
}
</style>